import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './oem_user_index.routes';
import OemUserService from '../../../../components/api/oem_user/oem_user.service';

export class OemUserIndexController {
  /*@ngInject*/
  constructor(OemUserService, $filter) {
    this.OemUserService = OemUserService;
  }

  $onInit() {
    this.OemUserService.oem_api.index(response => {
      this.userList = response;
    });
  }
}

export default angular.module('leptonApp.oemUserIndex', [uiRouter, OemUserService])
  .config(routing)
  .component('oemUserIndex', {
    template: require('./oem_user_index.html'),
    controller: OemUserIndexController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/oem_user/index/oem_user_index.component.js